import { IFormTemplate } from '@/shared/interfaces/form-template';
import { formSettingsEn } from '@/translations/form-settings';

export const formSettingsTemplates: IFormTemplate[] = [
  {
    title: formSettingsEn.formSettings.contentBlocks.name.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.name.subtitle,
    icon: 'fas fa-text',
    payload: {
      name: 'name',
      type: 'text',
      label: formSettingsEn.formSettings.contentBlocks.name.label,
      subtype: 'text',
      required: true,
      saveType: 'name',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.email.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.email.subtitle,
    icon: 'fas fa-envelope',
    payload: {
      name: 'email',
      type: 'text',
      label: formSettingsEn.formSettings.contentBlocks.email.label,
      subtype: 'email',
      required: true,
      saveType: 'email',
      validate: 'email',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.phone.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.phone.subtitle,
    icon: 'fas fa-phone',
    payload: {
      name: 'phone',
      type: 'text',
      label: formSettingsEn.formSettings.contentBlocks.phone.label,
      subtype: 'tel',
      saveType: 'phone',
      validate: 'phone',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.inquiringProperty.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.inquiringProperty.subtitle,
    icon: 'fas fa-question',
    payload: {
      name: 'inquiring-about-an-apartment',
      type: 'radio-group',
      label: formSettingsEn.formSettings.contentBlocks.inquiringProperty.label,
      values: [
        {
          label: formSettingsEn.formSettings.contentBlocks.inquiringProperty.yes,
          value: 'Yes',
        },
        {
          label: formSettingsEn.formSettings.contentBlocks.inquiringProperty.no,
          value: 'No',
          selected: true,
        },
      ],
      saveType: 'property_toggle',
      behaviour: 'property-toggle',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.selectCity.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.selectCity.subtitle,
    icon: 'fas fa-city',
    payload: {
      name: 'select-a-city',
      type: 'select',
      label: formSettingsEn.formSettings.contentBlocks.selectCity.label,
      values: [
        {
          label: formSettingsEn.formSettings.contentBlocks.selectCity.pleaseSelect,
          value: '',
          selected: true,
        },
      ],
      saveType: 'city_id',
      behaviour: 'property-choice',
      dataSourceType: 'cities',
      dataSourceLabelField: 'city_name',
      dataSourceValueField: 'city_id',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.selectProperty.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.selectProperty.subtitle,
    icon: 'fas fa-home',
    payload: {
      name: 'select-a-property',
      type: 'select',
      label: formSettingsEn.formSettings.contentBlocks.selectProperty.label,
      values: [
        {
          label: formSettingsEn.formSettings.contentBlocks.selectProperty.pleaseSelect,
          value: '',
          selected: true,
        },
      ],
      saveType: 'building_id',
      behaviour: 'property-choice',
      dataSourceType: 'properties',
      dataSourceLabelField: 'building_name',
      dataSourceValueField: 'id',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.selectUnitType.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.selectUnitType.subtitle,
    icon: 'fas fa-home',
    payload: {
      name: 'select-a-unit-type',
      type: 'select',
      label: formSettingsEn.formSettings.contentBlocks.selectUnitType.label,
      values: [
        {
          label: formSettingsEn.formSettings.contentBlocks.selectUnitType.pleaseSelect,
          value: '',
          selected: true,
        },
      ],
      saveType: 'suite_type_id',
      behaviour: 'property-dependent',
      dataSourceType: 'suites',
      dataSourceLabelField: 'type_name',
      dataSourceValueField: 'id',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.unitNumber.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.unitNumber.subtitle,
    icon: 'fas fa-hashtag',
    payload: {
      name: 'unit-number',
      type: 'text',
      label: formSettingsEn.formSettings.contentBlocks.unitNumber.label,
      subtype: 'text',
      saveType: 'unit',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.numberOfBedrooms.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.numberOfBedrooms.subtitle,
    icon: 'fas fa-hashtag',
    payload: {
      max: '',
      min: '',
      name: 'number-of-bedrooms',
      type: 'number',
      label: formSettingsEn.formSettings.contentBlocks.numberOfBedrooms.label,
      saveType: 'num_bedrooms',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.moveInDate.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.moveInDate.subtitle,
    icon: 'fas fa-calendar',
    payload: {
      minDate: '',
      name: 'move-in-date',
      type: 'text',
      label: formSettingsEn.formSettings.contentBlocks.moveInDate.label,
      subtype: 'date',
      saveType: 'move_in_date',
      validate: 'date',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.comments.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.comments.subtitle,
    icon: 'fas fa-comment-alt-lines',
    payload: {
      name: 'comments',
      type: 'textarea',
      label: formSettingsEn.formSettings.contentBlocks.comments.label,
      saveType: 'comments',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.textField.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.textField.subtitle,
    icon: 'fas fa-text',
    payload: {
      name: 'text-field',
      type: 'text',
      label: formSettingsEn.formSettings.contentBlocks.textField.label,
      subtype: 'text',
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.selectBox.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.selectBox.subtitle,
    icon: 'far fa-check-square',
    payload: {
      name: 'select-box',
      type: 'select',
      label: formSettingsEn.formSettings.contentBlocks.selectBox.label,
      values: [
        {
          label: '',
          value: '',
        },
      ],
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.checkbox.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.checkbox.subtitle,
    icon: 'far fa-check-square',
    payload: {
      name: 'checkbox',
      type: 'checkbox',
      label: formSettingsEn.formSettings.contentBlocks.checkbox.label,
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.groupedCheckboxes.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.groupedCheckboxes.subtitle,
    icon: 'far fa-check-square',
    payload: {
      name: 'grouped-checkboxes',
      type: 'checkbox-group',
      label: formSettingsEn.formSettings.contentBlocks.groupedCheckboxes.label,
      values: [
        {
          label: formSettingsEn.formSettings.contentBlocks.groupedCheckboxes.option1,
          value: 'option-1',
          selected: true,
        },
      ],
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.radioButtons.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.radioButtons.subtitle,
    icon: 'far fa-check-square',
    payload: {
      name: 'radio-buttons',
      type: 'radio-group',
      label: formSettingsEn.formSettings.contentBlocks.radioButtons.label,
      values: [
        {
          label: formSettingsEn.formSettings.contentBlocks.radioButtons.option1,
          value: 'option-1',
          selected: true,
        },
        {
          label: formSettingsEn.formSettings.contentBlocks.radioButtons.option2,
          value: 'option-2',
        },
        {
          label: formSettingsEn.formSettings.contentBlocks.radioButtons.option3,
          value: 'option-3',
        },
      ],
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.textArea.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.textArea.subtitle,
    icon: 'fas fa-text',
    payload: {
      name: 'text-area',
      type: 'textarea',
      label: formSettingsEn.formSettings.contentBlocks.textArea.label,
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.fileUpload.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.fileUpload.subtitle,
    icon: 'fas fa-upload',
    payload: {
      name: 'file-upload',
      type: 'file',
      label: formSettingsEn.formSettings.contentBlocks.fileUpload.label,
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.displayText.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.displayText.subtitle,
    icon: 'fas fa-paragraph',
    payload: {
      name: 'display-text',
      type: 'paragraph',
      label: formSettingsEn.formSettings.contentBlocks.displayText.label,
    },
  },
  {
    title: formSettingsEn.formSettings.contentBlocks.number.title,
    subtitle: formSettingsEn.formSettings.contentBlocks.number.subtitle,
    icon: 'fas fa-hashtag',
    payload: {
      name: 'number',
      type: 'number',
      label: formSettingsEn.formSettings.contentBlocks.number.label,
    },
  },
];

export const tourFormSettingsTemplate = formSettingsTemplates.map((a) => ({
  ...a,
  payload: a.payload
    ? {
      ...a.payload,
      saveType: '',
    }
    : { name: '' },
})).filter((a) => a.payload?.name !== 'select-a-city' && a.payload?.name !== 'select-a-property');
